import { Stack } from '@mui/material';
import { ListSkeletonProps } from '../Skeleton.types';
import { RowSkeleton, ClientSkeleton } from './RowSkeleton';

export const ListSkeleton = (props: ListSkeletonProps) => {
    const { sx } = props;

    if (props.client) {
        return (
            <Stack spacing={1.5} sx={sx}>
                <ClientSkeleton />
                <ClientSkeleton />
                <ClientSkeleton />
            </Stack>
        );
    }

    const { avatar, actions } = props;

    return (
        <Stack spacing={1.5} sx={sx}>
            <RowSkeleton avatar={avatar} actions={actions} />
            <RowSkeleton avatar={avatar} actions={actions} />
            <RowSkeleton avatar={avatar} actions={actions} />
        </Stack>
    );
};
